// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_7a3fb80146--pagination--SIf_R","pages-list":"_7a3fb80146--pages-list--OcUXj","page":"_7a3fb80146--page--Gby6K"};